// Single source of truth for the user "avatar ball" initials (Matching balls boards #109).
// The main-UI corner avatar (IconRail) and the board comment avatars must show identical
// initials: the first two characters of the display name (username, else email).
export const avatarInitials = (userOrString) => {
    if (!userOrString) return 'U';
    const src = typeof userOrString === 'string'
        ? userOrString
        : (userOrString.username || userOrString.email || '');
    return (src || 'U').slice(0, 2).toUpperCase();
};

// Contacts Hub initials ball (Agenda TO Contacts — Phase B, FE-3). Distinct from
// avatarInitials (which takes first-two-chars of the whole name): here TWO+ words
// take the first initial of the FIRST and the first initial of the LAST word
// ("Christian Graf" → "CG"), while a SINGLE word takes its first two letters
// ("Charlie" → "CH"). Uppercase. Do NOT fold this into avatarInitials — the rail
// / board-comment avatars depend on the first-two-chars behaviour.
export const contactInitials = (name) => {
    const parts = (name || '').trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
